import axios from 'axios'

const apiVendor = axios.create({
    baseURL: process.env.VUE_APP_VENDOR_BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})

export default apiVendor